import { styled } from "@mui/material";
import React from "react";
import Chart from "react-apexcharts";

const StyledChart = styled(Chart)`
  .apexcharts-xaxis-label:first-child {
    transform: translateX(-20px);
  }
`;

const NoDataMessage = styled("div")`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 400px;
  font-size: 16px;
  color: #8089a8;
`;

const TimeSeriesChart = ({ series, fromDate, toDate }) => {

  const rawExecutionData = Array.isArray(series?.[0]?.data)
    ? series[0].data
    : [];

  // ❗ very important
  if (rawExecutionData.length === 0) {
    return <NoDataMessage>No data available</NoDataMessage>;
  }

  const normalizeExecutionData = (data) => {
    const MIN_DURATION_MS = 500;

    return data.map((item) => {
      if (!Array.isArray(item?.y) || item.y.length !== 2) {
        return item;
      }

      let start = item.y[0];
      let end = item.y[1];

      // handle zero-duration jobs
      if (start === end) {
        return {
          ...item,
          y: [start, start + MIN_DURATION_MS],
          __aborted: true,
        };
      }

      return {
        ...item,
        y: [start, end],
      };
    });
  };

  const executionData = normalizeExecutionData(rawExecutionData);

  const dataMin = Math.min(...executionData.map(d => d.y[0]));
  const dataMax = Math.max(...executionData.map(d => d.y[1]));

  const axisStart = fromDate.valueOf();
  const axisEnd   = toDate.valueOf();

  // small padding to avoid clipping (1 second)
  const PADDING = 1000;

  const finalMin = Math.min(axisStart, dataMin) - PADDING;
  const finalMax = Math.max(axisEnd, dataMax) + PADDING;

  const safeSeries = [
    {
      ...series[0],
      data: executionData,
    },
  ];


  if (executionData.length === 0) {
    return <NoDataMessage>No data available</NoDataMessage>;
  }

  const options = {
  chart: {
    type: "rangeBar"
  },
  plotOptions: {
    bar: {
      horizontal: true
    }
  },
  xaxis: {
    type: "datetime",
    min: finalMin,
    max: finalMax,
    labels: {
      datetimeUTC: false,
      format: "HH:mm"
    }
  }
};

  console.log("FROM", new Date(fromDate));
console.log("TO", new Date(toDate));
console.log(
  "DATA RANGE",
  new Date(rawExecutionData[0].y[0]),
  new Date(rawExecutionData[rawExecutionData.length - 1].y[1])
);

  return (
    <StyledChart
      options={options}
      series={safeSeries}   
      type="rangeBar"
      height={400}
    />
  );
};

export default TimeSeriesChart;